import React from 'react';
import type { CandidateLegalTechSkill, Taxonomy } from '@axiom/validation';

import { CondensedHeader } from '../../content/CondensedHeader/CondensedHeader';
import { ParagraphHeader } from '../../content/ParagraphHeader/ParagraphHeader';
import { CandidateTaxonomyUtil } from '../../../utils/candidate-taxonomy-util';
import { CondensedLarge } from '../../content/CondensedLarge/CondensedLarge';
import { Layout } from '../../layout/Layout/Layout';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { LayoutItem } from '../../layout/Layout/LayoutItem';

export type LegalTechSkillsDisplayType = {
  condensed?: boolean;
  legalTechSkills: CandidateLegalTechSkill[] | null;
  name?: string;
  taxonomy: Taxonomy;
};

export const LegalTechSkillsDisplay = ({
  condensed = false,
  legalTechSkills,
  name = 'LEGAL_TECH_SKILLS_DISPLAY',
  taxonomy,
}: LegalTechSkillsDisplayType) => {
  const formattedLegalTechSkills =
    CandidateTaxonomyUtil.getDisplayableLegalTechSkills(legalTechSkills);

  if (Object.keys(formattedLegalTechSkills).length === 0) {
    return null;
  }

  const HeaderComponent = condensed ? CondensedHeader : ParagraphHeader;
  const TextComponent = condensed ? CondensedLarge : Paragraph;

  return (
    <Layout direction="vertical" verticalGutter="16px" name={name}>
      {Object.entries(formattedLegalTechSkills).map(([category, skills]) => (
        <LayoutItem name="LEGAL_TECH_SKILL_CATEGORY" key={category}>
          <HeaderComponent name={`LEGAL_TECH_SKILL_CATEGORY_${category}`}>
            {taxonomy.legalTechSkillCategories[category]?.displayName}
          </HeaderComponent>
          <TextComponent name={`LEGAL_TECH_SKILLS_LIST_${category}`}>
            {skills
              .map(skill => taxonomy.legalTechSkills[skill]?.displayName)
              .join('; ')}
          </TextComponent>
        </LayoutItem>
      ))}
    </Layout>
  );
};
